import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Region } from "./region.model";

@Injectable()
export class RegionService {
  private http = inject(HttpClient);

  getRegions(): Observable<{ regions: Region[] }> {
    return this.http.get<{ regions: Region[] }>("regions");
  }
}
